import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/identity-findings/$id')({
  beforeLoad: () => getTitleContextSlice('Identity Finding'),
  staticData: { owner: CodeOwner.IDNP },
});
